import React from "react";
import "./index.css";
import "react-loading-skeleton/dist/skeleton.css";

const Pagination = ({
  totalPages,
  currentPage,
  setCurrentPage,
}: {
  totalPages: number;
  currentPage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxPageNumbersToShow = 5; // Number of page links to show around the current page
    const startPage = Math.max(
      1,
      currentPage - Math.floor(maxPageNumbersToShow / 2)
    );
    const endPage = Math.min(totalPages, startPage + maxPageNumbersToShow - 1);

    if (startPage > 1) {
      pageNumbers.push(1);
      if (startPage > 2) {
        pageNumbers.push("...");
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pageNumbers.push("...");
      }
      pageNumbers.push(totalPages);
    }

    return pageNumbers;
  };

  return (
    <nav>
      <ul className="pagination-search">
        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
          <a
            onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
            className="page-link"
          >
            <svg
              aria-hidden="true"
              className="lexicon-icon lexicon-icon-angle-left"
              focusable="false"
            >
              <use href="/o/dialect-theme/images/clay/icons.svg#angle-left"></use>
            </svg>
          </a>
        </li>
        {renderPageNumbers().map((number, index) =>
          number === "..." ? (
            <li key={index} className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          ) : (
            <li
              key={index}
              className={`page-item ${currentPage === number ? "active" : ""}`}
            >
              <a
                onClick={() => setCurrentPage(Number(number))}
                className="page-link"
              >
                {number}
              </a>
            </li>
          )
        )}
        <li
          className={`page-item ${
            currentPage === totalPages ? "disabled" : ""
          }`}
        >
          <a
            onClick={() =>
              currentPage < totalPages && setCurrentPage(currentPage + 1)
            }
            className="page-link"
          >
            <svg
              aria-hidden="true"
              className="lexicon-icon lexicon-icon-angle-right"
              focusable="false"
            >
              <use href="/o/dialect-theme/images/clay/icons.svg#angle-right"></use>
            </svg>
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
